module.exports = __webpack_public_path__ + "img/product-unit.55b82d0e.svg";